import { useLocation, useNavigate } from "react-router-dom";
import { Menu, ArrowLeft } from "lucide-react";

const Header = ({ toggleSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const getBreadcrumb = () => {
    let paths = location.pathname.split("/").filter(Boolean);

    // Hide ID/UUID
    if (
      paths.length > 1 &&
      /^[0-9a-fA-F-]{8,}$/.test(paths[paths.length - 1])
    ) {
      paths = paths.slice(0, -1);
    }

    if (paths.length === 1 && paths[0].toLowerCase() === "dashboard") {
      return "Welcome to O4S HR Setu";
    }

    const formatted = paths.map((segment) =>
      segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    );

    return formatted.join(" / ");
  };

  return (
    <header
      className="fixed top-0 z-40 h-[60px] bg-white shadow flex items-center px-3 sm:px-4 transition-all duration-300"
      style={{
        left: window.innerWidth >= 768 ? "var(--sidebar-width)" : "0px",
        width:
          window.innerWidth >= 768
            ? "calc(100% - var(--sidebar-width))"
            : "100%",
      }}
    >
      {/* LEFT SECTION */}
      <div className="flex items-center gap-2 min-w-0">
        {/* Mobile Menu */}
        <button
          onClick={toggleSidebar}
          className="md:hidden p-2 rounded-lg hover:bg-gray-100"
        >
          <Menu size={20} />
        </button>

        {/* Desktop Back */}
        {location.pathname !== "/Dashboard" && (
          <button
            onClick={handleBack}
            className="hidden md:flex items-center justify-center w-9 h-9 rounded-full border shadow-sm hover:bg-gray-100"
          >
            <ArrowLeft size={18} />
          </button>
        )}

        {/* Breadcrumb */}
        <h1 className="font-semibold text-blue-700 text-sm sm:text-base md:text-lg leading-tight break-words line-clamp-2">
          {getBreadcrumb()}
        </h1>
      </div>
    </header>
  );
};

export default Header;
